import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function DiscountSlider() {
    const [promocodeAllData, setPromocodeAllData] = useState({});
    const fetchAllPromoCodes = async () => {
        try {
          const user_id = localStorage.getItem('userid');
          const session_key = localStorage.getItem('session_key');
          
          const response = await fetch('https://www.liebigsagrochem.com/api/promo/get_promo/v1', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id, sessionkey: session_key }),
          });
          
          const data = await response.json();
          setPromocodeAllData(data);
        } catch (error) {
          console.error('Error fetching promocodes:', error);
        }
      };
    
      useEffect(() => {
        fetchAllPromoCodes();
      }, []);
  return (
    <div>
        <OwlCarousel 
            items={1}
            className="owl-theme"
            loop
            nav={false}
            dots={false}
            autoplay={true}
            margin={8}
            smartSpeed="650"
            >
            {
                promocodeAllData?.data?.map((item, index) => (
                    <div className='item' key={index}>
                        <div className='discount-code text-center py-1'>-- {item.description} --</div>
                    </div>
                ))
            }
        </OwlCarousel>
    </div>
  )
}

export default DiscountSlider
